export default "__VITE_ASSET__7WK26Tq1__"